import './Navigation.css';
import { useContext } from 'react';
import { LanguageContext } from './App';
import { useNavigate } from 'react-router-dom';

function Navigation({isCartFull, setCartFull }) {
    const { language } = useContext(LanguageContext);
    const navigate = useNavigate();

    // Обработчик клика на search-input
    const handleCartClick = () => {
        setCartFull(false);
        navigate('/cart');
    };

    const handleSearchClick = () => {
        navigate('/search');
    };

    const handlePartnerClick = () => {
        navigate('/partner');
    };

    const handleHomeClick = () => {
        navigate('/');
    };

    const handleCabinetClick = () => {
        navigate('/cabinet');
    };

    return (
        <div className='navigation' id='navigation'>
            <div className='nav-element' onClick={handleHomeClick}><img src='/images/nav-icon-1.png' /></div>
            <div className='nav-element' onClick={handleSearchClick}><img src='/images/nav-icon-2.png' /></div>
            <div className='nav-element' onClick={handlePartnerClick}><img src='/images/nav-icon-4.png' /></div>
            <div className='nav-element' onClick={handleCartClick}><div className='cart-full' style={{ background: isCartFull ? '#4886B9' : 'transparent'}}></div><img src='/images/nav-icon-3.png' /></div>
            <div className='nav-element' onClick={handleCabinetClick}><img src='/images/nav-icon-5.png' /></div>
        </div>
    );
}

export default Navigation;
